import type { PropsWithChildren } from "react";
import React, { createContext, useContext } from "react";

import type { FlowProviderProps, FlowType } from "./types";

export const FlowContext = createContext<FlowType>("mobile");

export const FlowProvider = ({
  flow,
  children,
}: PropsWithChildren<FlowProviderProps>) => (
  <FlowContext.Provider value={flow}>{children}</FlowContext.Provider>
);

export const useFlow = () => {
  return useContext(FlowContext);
};
